angular.module('callX').controller('ApplicationPageCtrl', ['$scope','$stateParams','$modal','UserService','$rootScope', '$state', 'toaster', function($scope,$stateParams,$modal,UserService, $rootScope,$state, toaster) {
    
    var username_agent = $stateParams.username;
    var userId = $stateParams.userId;
    $scope.role ;
    $scope.getuserRole ;
    $scope.getsalesRole ;

    $scope.searchPage = false;
    $scope.tableContentLoading=false; 
    $scope.tableContentLoadingSearch=false;
    $scope.statusArray = ['Approved', 'Declined', 'Underwriting']

    $scope.setAgentFirsAandLastName = function() {
        $scope.username_firstName = window.localStorage.getItem("first_name")
        $scope.username_lastName = window.localStorage.getItem("last_name")
        $scope.user_name = window.localStorage.getItem("user_name")
        $scope.user_id = window.localStorage.getItem("user_id")
        $scope.role = window.localStorage.getItem("role");

        if ($scope.role === 'AGENT') {
            $scope.role = 'salesagent';
        }        
        $scope.email = window.localStorage.getItem("email")
        if($scope.role == 'useragent'){
            $scope.getuserRole = $scope.role;
            $scope.getAgentStats();
        }else if($scope.role == 'salesagent'){
            $scope.getsalesRole = $scope.role;
            $scope.getsalesAgentStats();
        }
    }

    $scope.limitTextLength = function(text) {
        return text.slice(0,4) + '..'
    }

    $scope.setAgentFirsAandLastName();

   
    // $scope.newPage =  false;
    // $scope.rootDispositionsArray = [];
    // $scope.dispositionsArray = [];

    $scope.currentPage = 1; 
    $scope.itemsPerPage = 20;
    $scope.maxSize = 3;
    $scope.applicationPageData = []

    // $scope.getCarriers = function(){
    //     console.log("------------------carrier")
    //     $scope.tableContentLoading = true;
    //     $rootScope.currentPage = 'application';

    //     var callbacks = {
    //     success: function(data) {
    //         console.log(data, "get contact data")
    //         $scope.carrierList = data;
    //        $scope.tableContentLoading = false;
    //         },
    //     failure: function(data) {
    //         $scope.tableContentLoading = false;
    //         }
    //     };
    //     UserService.getCarrierDetails(callbacks); 
    // } 
    // $scope.getCarriers();

    $scope.getApplicationDetails = function(){
        $scope.tableContentLoading = true;
        $rootScope.currentPage = 'application';
        $state.go('app.sales-agent.applications', { username: $scope.user_name, userId: $scope.user_id });
        var callbacks = {
        success: function(data) {
                $scope.applicationPageData = data.data.applications_response_dto; 
                $scope.totalPages = data.data.total_pages;
                $scope.totalItems = data.data.total_elements;
                $scope.tableContentLoading = false;
            },
        failure: function(data) {
                $scope.tableContentLoading = false;
            }
        };
        UserService.getApplicationDetails($scope.user_id, $scope.currentPage - 1, $scope.itemsPerPage, callbacks); 
    } 
    $scope.getApplicationDetails();   

    $scope.pageChanged = function() {
        $scope.tableContentLoading = true;

        var callbacks = {
        success: function(data) {
                $scope.applicationPageData = data.data.applications_response_dto;
                $scope.totalPages = data.data.total_pages;
                $scope.totalItems = data.data.total_elements;

                $scope.tableContentLoading = false;
            },
        failure: function(data) {
            $scope.tableContentLoading = false;
            }
        }; 
        UserService.getApplicationDetails($scope.user_id,$scope.currentPage-1,$scope.itemsPerPage,callbacks);  
    } 

    // sort by alphabetical order
    $scope.sortByName = function(data) {
        return data.sort(function(a, b) {
            return a.name.localeCompare(b.name);
        });
    };

    $scope.getCarrierArray = function(){
    	var callbacks = {
            success: function (data) {
                $scope.companies = $scope.sortByName(data);
             },
            failure: function (data) {
                toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
            }

        };
        UserService.getCarrierDetailsForFilters(callbacks);
    };

    $scope.getProductsBasedOnCarrier = function(carrierId){
        // $scope.products = []
    	var callbacks = {
            success: function (data) {
                $scope.product = '';
                $scope.products = data;
                $scope.filterApplicationRecords()
             },
            failure: function (data) {
                toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
            }

        };
        UserService.getProductsBasedOnCarrier(carrierId, callbacks);
    }; 

    $scope.getAllProducts = function(){
    	var callbacks = {
            success: function (data) {
                $scope.products = data;
             },
            failure: function (data) {
                toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
            }

        };
        UserService.getAllProductsForFilters(callbacks);
    };

    $scope.getCarrierArray()
    $scope.getAllProducts();

    $scope.onCompanyFilter = function(companyId) {
        if(companyId === ''){
             $scope.resetApplicationFilters();
             $scope.getAllProducts();
        }
        else if(companyId){
             $scope.selectedCompany = $scope.companies.find(function(company) {
                    if(company.id == companyId){
                       return company.name;
                    }
                });
                $scope.getProductsBasedOnCarrier(companyId)
                // $scope.filterApplicationRecords()
        }else if($scope.products.length === 0 && $scope.product){

        }
    }

    $scope.onProductFilter = function(productId){
        if(productId === ''){
            $scope.resetApplicationFilters();
            $scope.getAllProducts();
        }else if(productId){
            $scope.selectedProduct = $scope.products.find(function(product) {
                if(product.id == productId){
                   return product.product_name;
                }
            });
            $scope.filterApplicationRecords();
        }
    }

    $scope.getAgentsArray = function(){
    	var callbacks = {
            success: function (data) {
                $rootScope.agentNames = $scope.sortByName(data);
             },
            error: function (error) {
                toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
            }
        };
        UserService.getAgentDetailsForFilters(callbacks);
    };
    $scope.getAgentsArray();


    // To format monthly and annual payment
    $scope.getFormattedMonthlyPayment = function(payment) {
        if (typeof payment === 'number') {
            return '$' + payment.toFixed(2) + '/mo';
        } else {
            console.warn('Invalid payment value:', payment);
            return '$0.00/mo'; 
        }
    };
    $scope.getFormattedAnnualPayment = function(payment) {
        if (typeof payment === 'number') {
            return '$' + payment.toFixed(2) + '/yr';
        } else {
            console.warn('Invalid payment value:', payment);
            return '$0.00/yr';
        }
    };

    // Date and time format changes 
    // $scope.extractDateFromTimestamp = function(timestamp) {
    //     if (typeof timestamp !== 'string') {
    //         throw new Error('Input must be a string');
    //     }
    //     var parts = timestamp.split(' ');
    //     return parts[0];
    // };   

    $scope.extractDateFromTimestamp = function(timestamp) {
        if (!timestamp) {
            return ''; 
        }
        var datePart = timestamp.split(' ')[0];
        var parts = datePart.split('-');
        if (parts.length !== 3) {
            throw new Error('Invalid date format');
        }
        var year = parts[0];
        var month = parts[1];
        var day = parts[2];
        // var shortYear = year.slice(2);
        // Format as DD/MM/YY
        return month + '/' + day + '/' + year;
    };

    $scope.applicationEditForm = function(edit_application){
        $scope.openApplicationEditFormModal(edit_application);
    } 

    $scope.formatPhoneNumber = function(phoneNumber) {
        if (!phoneNumber || phoneNumber.length !== 11) {
            return phoneNumber; 
        }
        if (phoneNumber.startsWith('1')) {
            phoneNumber = phoneNumber.substring(1);
        }
        return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    };

    // $scope.getValidContactName = function(contactName) {
    //     // console.log(contactName)
    //     var invalidValues = ['null', 'Null', 'null null', null, '', 'Null null', 'null Null'];
    
    //     if (invalidValues.includes(contactName) || !contactName) {
    //         return 'Unknown Contact';
    //     }
    //     return $scope.convertToCamelCase(contactName);
    // };

    $scope.getValidContactName = function(contactName) {
        // Log the incoming contactName for debugging
        // console.log(contactName);
        var normalizedContactName = (contactName || '').trim().toLowerCase();
        var invalidValues = ['null', 'null null', ''];
        if (invalidValues.includes(normalizedContactName) || 
            normalizedContactName.includes('null')) {
            return 'Unknown Contact';
        }
        return $scope.convertToCamelCase(contactName);
    };

    $scope.convertToCamelCase = function(contactName) {
        if (contactName) {
           return contactName = contactName
                .toLowerCase()
                .split(' ')
                .map(function(word) {
                    return word.charAt(0).toUpperCase() + word.slice(1);
                })
                .join(' ');
        }
    };

    $scope.openApplicationEditFormModal = function(edit_application) {
        var modalInstance = $modal.open({
            templateUrl: 'tpl/blocks/application_page_edit.html',
            controller: 'ApplicationPageEditCtrl',
            size: 'md',
            windowClass: 'custom-rounded-modal',
            backdrop: 'static',
            resolve: {
                object: function () {
                    return {
                        application:edit_application
                    }
                }
            }
        });
            modalInstance.result.then(function (selectedItem) {
                    // $scope.selected = selectedItem;
                    if (selectedItem == 'ok') {
                        $scope.getApplicationDetails();
                    }
            }, function () {
            
            });
    } 

    $scope.applicationToContactDetailsPage = function(contactName, PhoneNumber){
        $rootScope.currentPage = 'contactpage'
        $state.go('app.sales-agent.details', { contactName: contactName, phoneNumber:PhoneNumber});
    } 

      //calendar starts  
      $scope.dpOpened1 = false;
      $scope.dpOpened2 = false;
 
      $scope.open = function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          $scope.dpOpened1 = !$scope.dpOpened1;
          $scope.dpOpened2 = !$scope.dpOpened2;
      };
   
      $scope.dateOptions = {
          formatYear: 'yyyy',
          startingDay: 0,
          class: 'datepicker',
          showWeeks:false
      };
   
        $scope.format = 'MM/dd/yyyy';
   
    $scope.$watch('$scope.submitted_date', function (newDate) {
        if(newDate){
            $scope.submitted_date = moment($scope.submitted_date).format("MM/dd/yyyy");
        }
     }); 
    // $scope.$watch('$scope.effective_date', function (newDate) {
    //     if(newDate){
    //         $scope.effective_date = moment(new Date($scope.effective_date)).format("MM/dd/yyyy");
    //     }
    // }); 

    // $scope.today = function() {
    //     var todayDate = new Date();
    //     $scope.minDate = todayDate;
    //     $scope.submitted_date = todayDate.toISOString().split('T')[0];
    //     $scope.effective_date = todayDate.toISOString().split('T')[0];
    // };
    // $scope.today();
    $scope.toggleMin = function() {
        $scope.minDate = new Date(); 
    };
    $scope.toggleMin();
  
    $scope.openDatePickerSubmitted = function($event) {
        // console.log("open submitted date")
        $event.preventDefault();
        $event.stopPropagation();
        $scope.openedTo = false;
        $scope.openedFrom = true;
    }; 

    $scope.openDatePickerEffective = function($event) {
    //    console.log("open effective date")
       $event.preventDefault();
       $event.stopPropagation();
       $scope.openedFrom = false;
       $scope.openedTo = true;
   };

      $scope.dateOptionsDatePicker = {
          formatYear: 'yy',
          startingDay: 0,
          class: 'datepicker',
        //   minDate: moment(),
          showWeeks:false
      };
      //calendar ends

$scope.format = 'MM/dd/yyyy';
$scope.isDatePickerOpen = false;
$scope.rangeStartDate = null;
$scope.rangeEndDate = null;

// Date options for date picker
$scope.dateOptionsDatePicker = {
    formatYear: 'yy',
    startingDay: 0, // Week starts on Sunday
    class: 'datepicker',
    showWeeks: false
};

// $scope.date = {
//     startDate: null, // 1 day ago
//     endDate: null // current date and time
// };


// $scope.SimplePickerChange = function(){
//   alert('hi');
//     $scope.date = {        
//       endDate: $scope.date.startDate.add(30, "days")
//     }
//     alert(JSON.stringify($scope.date));
// };


// $scope.startDate = 'Nov 01, 2024';
// $scope.endDate = 'Nov 30, 2024';

$scope.date = { dateRangeValue: null }; // No initial date range

$scope.testEffectiveDate = function(dateRangeValue) {
    console.log('testEffectiveDate Date Range Value:', dateRangeValue);
    $scope.effective_date = dateRangeValue;
    $scope.filterApplicationRecords()
};

$scope.submittedDate = { dateRangeValue: null }; // No initial date range

$scope.testSubmittedDate = function(dateRangeValue) {
    console.log('testSubmittedDate Date Range Value:', dateRangeValue);
    $scope.submitted_date = dateRangeValue;
    $scope.filterApplicationRecords()
};

// $scope.testSubmittedDate = function(dateRangeValue) {
//     console.log('Date Range Value:', dateRangeValue);
//     $scope.submitted_date = dateRangeValue;
//     $scope.filterApplicationRecords()
// };

$scope.$on('dateObjUpdate', function(event, dateObj) {
    console.log('here')
    $scope.testEffectiveDate(dateObj.dateRangeValue);
    // $scope.testSubmittedDate(dateObj.dateRangeValue);
});

$scope.openDatePickerRangeIcon = function() {
    $('#custom-date-picker').trigger('click');
};
$scope.openDatePickerRangeIcon2 = function() {
    $('#custom-date-picker-2').trigger('click');
};

// Function to open the date picker
$scope.openDateRangePicker = function($event) {
    $event.preventDefault();
    $event.stopPropagation();
    if (!$scope.isDatePickerOpen) {
        $scope.isDatePickerOpen = true;
    }
};

// Watch for changes in effective_date to handle range selection

// $scope.$watch('effective_date', function(newDate) {
//     console.log('newDate',newDate)
//     if (!newDate) return;
//     newDate = moment(newDate).isValid() ? moment(newDate) : null;
//     if (!newDate) return;
//     if (!$scope.rangeStartDate) {
//         $scope.rangeStartDate = newDate;
//         $scope.effective_date = $scope.rangeStartDate.format("MM/DD/YYYY") + " - ";
//         $scope.isDatePickerOpen = true;
//     } else {
//         $scope.rangeEndDate = newDate;
//         if ($scope.rangeStartDate.isAfter($scope.rangeEndDate)) {
//             var temp = $scope.rangeStartDate;
//             $scope.rangeStartDate = $scope.rangeEndDate;
//             $scope.rangeEndDate = temp;
//         }
//         $scope.effective_date = $scope.rangeStartDate.format("MM/DD/YYYY") + " - " + $scope.rangeEndDate.format("MM/DD/YYYY");
//         $scope.filterApplicationRecords(); 
//         $scope.isDatePickerOpen = false; 
//         $scope.rangeStartDate = null; 
//         $scope.rangeEndDate = null;
//     }
// });

      function formatPhoneNumberWithoutDashes(phoneNumber) {
        // Remove dashes and spaces
        const cleanedNumber = phoneNumber.replace(/[-\s]/g, '');
        
        // Add the country code '1' at the beginning
        return '1' + cleanedNumber;
    }

    $scope.formatDateToYYYYMMDD = function(val) {

        var date = new Date(val);
        if (typeof val === 'string' && val.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
            var parts = val.split('/');
            var day = parseInt(parts[0], 10);
            var month = parseInt(parts[1], 10) - 1; // month is 0-based in JS Date
            var year = parseInt(parts[2], 10);
    
            // Create a Date object with the parsed values
            date = new Date(year, month, day);
        }
        var year = date.getFullYear();
        var month = String(date.getMonth() + 1); 
        var day = String(date.getDate());
        month = month.length === 1 ? '0' + month : month;
        day = day.length === 1 ? '0' + day : day;
        return year + '-' + month + '-' + day + " " + '00:00:00';
        // return day + '/' + month + '/' + year + " " + '00:00:00';
    }

    // $scope.formatDateRangeToYYYYMMDD = function(val) {
    //     if (!val) return ''; 
    //     if (typeof val === 'string' && val.match(/^\d{2}\/\d{2}\/\d{4} - \d{2}\/\d{2}\/\d{4}$/)) {
    //         var dates = val.split(' - ');
    //         var startDateParts = dates[0].split('/');
    //         var endDateParts = dates[1].split('/');
    
    //         // Parse start date
    //         var startDay = parseInt(startDateParts[1], 10);
    //         var startMonth = parseInt(startDateParts[0], 10) - 1; 
    //         var startYear = parseInt(startDateParts[2], 10);
    //         var startDate = new Date(startYear, startMonth, startDay);
    
    //         // Parse end date
    //         var endDay = parseInt(endDateParts[1], 10);
    //         var endMonth = parseInt(endDateParts[0], 10) - 1; 
    //         var endYear = parseInt(endDateParts[2], 10);
    //         var endDate = new Date(endYear, endMonth, endDay);
    
    //         // Format both dates as "YYYY-MM-DD 00:00:00"
    //         var formatDate = function(date) {
    //             var year = date.getFullYear();
    //             var month = String(date.getMonth() + 1).padStart(2, '0');
    //             var day = String(date.getDate()).padStart(2, '0');
    //             return year + '-' + month + '-' + day + " 00:00:00";
    //         };
    //         return formatDate(startDate) + ' - ' + formatDate(endDate);
    //     }
    
    //     // If input doesn't match expected format, return as-is or handle as needed
    //     return val;
    // };

    $scope.formatDateRangeToYYYYMMDD = function(val) {
        if (!val) return ''; 
    
        // If val is an array of dates
        if (Array.isArray(val) && val.length === 2) {
            var startDate = new Date(val[0]);
            var endDate = new Date(val[1]);
        
            // Format the dates as "YYYY-MM-DD 00:00:00"
            var formatDate = function(date) {
                var year = date.getFullYear();
                var month = String(date.getMonth() + 1).padStart(2, '0');
                var day = String(date.getDate()).padStart(2, '0');
                return year + '-' + month + '-' + day + " 00:00:00";
            };
            
            return formatDate(startDate) + ' - ' + formatDate(endDate);
        }
    
        // If input doesn't match expected format, return as-is or handle as needed
        return val;
    };
    
    

     $scope.filterApplicationRecords = function(currentSearchNumber) {
        // console.log($scope.submitted_date, $scope.effective_date, "filter records")
        var filtersApplicationObject = { 
            filters:[]
         };
         $scope.searchPage = true;
         $scope.tableContentLoadingSearch = true;
       
        // Filter by name or phone number
        if ($scope.userNameOrPhone) {
            // console.log($scope.userNameOrPhone, "get value")
            var input = $scope.userNameOrPhone.trim();
    
            // Check if the input is a number (phone number)
            if (/^\d{3}-\d{3}-\d{4}$/.test(input) || /^\d+$/.test(input.replace(/-/g, ''))) {
                filtersApplicationObject.filters.push({
                    key: "contactPhoneNumber",
                    operation: "contains",
                    value: formatPhoneNumberWithoutDashes(input)
                });
            } else {
                filtersApplicationObject.filters.push({
                    key: "contactName",
                    operation: "contains",
                    value: input
                });
            }
        }

        // Set ref_from property to $scope.getDate value
        // if ($scope.getDate) {
        //     filtersContactObject.ref_from = $scope.getDate;
        // }
    
        // pass salesagentId 
        // if ($scope.user_id) {
        //     var salesUserId = {
        //         "key": "salesAgentId",
        //         "operation": "=",
        //         "value": $scope.user_id
        //     };
        //     filtersApplicationObject.filters.push(salesUserId);
        // }

        // Check if carrier has a value selected
        if ($scope.company) {
            var carrierFilter = {
                key: "carrierName",
                operation: "equals", 
                value: $scope.selectedCompany.name
            };
            filtersApplicationObject.filters.push(carrierFilter);
        }
    
        // Check if product has a value selected
        if ($scope.product) {

            // if(!$scope.company){
            //     toaster.pop('error', 'Error', "Carrier filter should be applied", 2000)
            // }

            var productFilter = {
                key: "productName", 
                operation: "equals", 
                value: $scope.selectedProduct.product_name
            };
            filtersApplicationObject.filters.push(productFilter);
        }

         // Check if status has a value selected
         if ($scope.status) {
            var statusFilter = {
                key: "status", 
                operation: "equals", 
                value: $scope.status
            };
            filtersApplicationObject.filters.push(statusFilter);
        }

         // Check if agent has a value selected
         if ($scope.agent) {
            var agentFilter = {
                key: "AgentName", 
                operation: "equals", 
                value: $scope.agent
            };
            filtersApplicationObject.filters.push(agentFilter);
        }

        if ($scope.agent) {
            var agentFilter = {
                key: "splitAgentName", 
                operation: "equals", 
                value: $scope.agent
            };
            filtersApplicationObject.filters.push(agentFilter);
        }

        if ($scope.submitted_date) {
            var submittedDateFilter = {
                key: "submittedDate", 
                operation: "equals", 
                value: $scope.formatDateRangeToYYYYMMDD($scope.submitted_date)
            };
            filtersApplicationObject.filters.push(submittedDateFilter);
        }

        console.log($scope.submitted_date, "submitted_date")
        console.log($scope.effective_date, "effective_date")
        if ($scope.effective_date) {
            var effectiveDateFilter = {
                key: "effectiveDate", 
                operation: "equals", 
                value: $scope.formatDateRangeToYYYYMMDD($scope.effective_date)
            };
            filtersApplicationObject.filters.push(effectiveDateFilter);
        }

        var agentFilter = {
            key: "agentId", 
            operation: "equals", 
            value: userId
        };
        filtersApplicationObject.filters.push(agentFilter);

        $scope.itemsSearchPerPage = 20;
        $scope.maxSearchSize = 3;

        if(currentSearchNumber){
            $scope.currentSearchPage = currentSearchNumber;
        }else{
            $scope.currentSearchPage = 0;
        }

        if($scope.currentSearchPage > 0){
            filtersApplicationObject.page = $scope.currentSearchPage - 1;
        }else {
            filtersApplicationObject.page = $scope.currentSearchPage;
        }

        filtersApplicationObject.size = $scope.itemsSearchPerPage;
        // console.log("applied filters", filtersApplicationObject)

            var callbacks = {
                success: function(data) {
                    // console.log("log search data contact ---------", data)

                    $scope.applicationPageData = data.data.applications;
                    $scope.totalPages = data.data.total_pages;
                    $scope.totalItems = data.data.total_records;
                    // $scope.filterApplication = true;
                    // console.log($scope.applicationPageData,$scope.totalPages,$scope.totalItems, "search data")

                    $scope.tableContentLoadingSearch = false;
                },
                failure: function(data) {
                    $scope.tableContentLoadingSearch = false;
                }
            };
            UserService.applicationPageReportsData(filtersApplicationObject, callbacks);
    };
    
     $scope.pageChangedSearch = function(){
        $scope.filterApplicationRecords($scope.currentSearchPage)
    }

    // reset filters 
    $scope.resetApplicationFilters = function() {
        $scope.date = { dateRangeValue: null }; 
        $scope.submittedDate = { dateRangeValue: null }; 
        $('#custom-date-picker').val(''); 
        $('#custom-date-picker-2').val(''); 
        $scope.userNameOrPhone = ''; 
        $scope.company = '';
        $scope.selectedCompany = '';
        $scope.selectedProduct = '';
        $scope.product = '';
        $scope.status = ''; 
        $scope.agent = '';
        $scope.submitted_date = '';
        $scope.effective_date = '';
        $scope.searchPage = false;
        $scope.getApplicationDetails();
        $scope.getAllProducts();
        // $scope.pageChanged ();  
    };


  }]);